// extracted by mini-css-extract-plugin
export default {"box":"InfoBox_box__qFQXX","title":"InfoBox_title__R8-qM","subtitle":"InfoBox_subtitle__x5IgZ"};